/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Ducks, User } from '@wit/vtv-x-foundation-lib';

export function useCurrentUser() {
  const users = useSelector(Ducks.Household.Selectors.data.getUsers);
  const currentUserId = useSelector(Ducks.Credentials.Selectors.getUserId);
  const [currentUser, setCurrentUser] = useState<User | undefined>();

  useEffect(() => {
    const user = users.find((cur) => cur.id === currentUserId);
    if (user) {
      setCurrentUser(user);
    } else {
      setCurrentUser(undefined);
    }
  }, [currentUserId, users]);

  return currentUser;
}
